/* tslint:disable */
/* eslint-disable */
export enum WorkScreenslideComponentsEffect {
  Schnee = 'Schnee'
}
